import { gridSize } from '@atlaskit/theme/constants';

export const NOTES_PANEL_ID = 'notes-sidebar';
export const NOTES_SIDEBAR_WIDTH = gridSize() * 46; // same as HELP_PANEL_WIDTH
